import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 48 — Tour de la pantalla de Cocina.
 * Página crítica para cocineros (usuarios no técnicos). Explica la agrupación
 * por destino (delivery empaca / comer_aquí emplata) y los dos estados.
 */
export const tourCocina: TourDefinition = {
  id: 'cocina',
  title: 'Cómo usar la pantalla de Cocina',
  steps: [
    {
      element: '[data-tour="cocina-header"]',
      popover: {
        title: '1. Pantalla de Cocina',
        description:
          'Aquí ves en tiempo real todos los pedidos que necesitan preparación. Los contadores muestran cuántos están pendientes (⏱️) y cuántos ya están listos (✅). La pantalla se actualiza sola cada 10 segundos.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="cocina-pendientes"]',
      popover: {
        title: '2. Pedidos pendientes — a preparar',
        description:
          'Los pedidos están agrupados por destino. 📦 Naranja = A domicilio: prepara en contenedor con bolsa. 🍽️ Verde = Comer aquí: emplata en plato. Cada tarjeta muestra el número de pedido, cliente, tiempo transcurrido y desglose de productos con cantidad y personalizaciones.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="cocina-listos"]',
      popover: {
        title: '3. Listos para entregar',
        description:
          'Pedidos que ya terminaste. Presiona "Marcar listo" cuando el plato esté terminado para avisarle al mesero. Para pedidos de comer aquí, el mesero puede marcar "Entregado en mesa" cuando lleve el plato a la mesa. Para delivery, el repartidor toma el pedido desde su pantalla.',
        side: 'top',
      },
    },
  ],
};
